// extracted by mini-css-extract-plugin
export var name = "styles-module__name___UaHv3";
export var quote = "styles-module__quote___qBzVA";
export var quoteBlock = "styles-module__quoteBlock___Z645D";
export var quoteContainer = "styles-module__quoteContainer___rYBVK";
export var role = "styles-module__role___l43VE";
export var title = "styles-module__title___EgbmV";